// extracted by mini-css-extract-plugin
export default {"barChart":"ChartBar_barChart__UrC32","amount":"ChartBar_amount__nH3Mj","fill":"ChartBar_fill__U6NsV","inner":"ChartBar_inner__tCbri","label":"ChartBar_label__pKoNA"};